import type { VentaAutorizacionPayload } from '../types/venta-form';

export interface SubmitAutorizacionOptions {
  authToken?: string;
  dashboardSessionId?: string;
  /** Formulario embebido sin sesión de la app. */
  embedToken?: string;
}

export async function submitAutorizacion(
  submitUrl: string,
  payload: VentaAutorizacionPayload,
  options: SubmitAutorizacionOptions = {}
): Promise<Record<string, unknown>> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (options.dashboardSessionId) {
    headers.Authorization = 'Bearer ' + options.dashboardSessionId;
  } else if (options.authToken) {
    headers.Authorization = 'Bearer ' + options.authToken;
  }
  if (options.embedToken) {
    headers['X-Embed-Token'] = options.embedToken;
  }

  const response = await fetch(submitUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const body = await response.text();
    let message = 'Error al registrar (' + response.status + ')';
    try {
      const data = JSON.parse(body) as { error?: string };
      if (data.error) message = data.error;
    } catch {
      if (body) message += ': ' + body.slice(0, 200);
    }
    throw new Error(message);
  }

  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text) as Record<string, unknown>;
  } catch {
    return { raw: text };
  }
}
